<h1 class="pb-5 font-brand text-28px font-bold text-neutral-800">
  {{ 'como.create-or-link-account.otp-step.title' | translate }}
</h1>
<form
  [formGroup]="form"
  class="pb-6"
>
  <label
    for="authCode"
    class="mb-1 block font-base text-sm font-normal leading-5 text-neutral-600"
    translate="como.link-account.enter-auth-code"
  ></label>
  <input
    id="authCode"
    type="text"
    formControlName="authCode"
    (keyup.enter)="onSubmit($event)"
    class="flex w-full border border-solid border-neutral-300 bg-neutral-50 px-5 py-8xs font-base text-base font-normal leading-5"
    [class.border-error-700]="
      authCodeErrorMessage ||
      (form.controls?.authCode?.errors &&
        (form.controls?.authCode?.dirty || form.controls?.authCode?.touched))
    "
  />
  @if (
    form.controls?.authCode?.invalid &&
    (form.controls?.authCode?.dirty || form.controls?.authCode?.touched)
  ) {
    @if (form.controls?.authCode?.errors) {
      <span
        class="absolute bottom-1 block font-base text-xs font-normal text-error-700"
        translate="como.link-account.errors.invalid-auth-code"
      ></span>
    }
  }
  @if (authCodeErrorMessage) {
    <span
      class="font-base text-xs font-normal text-error-700"
      [translate]="authCodeErrorMessage"
    ></span>
  }
</form>

<div class="flex flex-col gap-2">
  @if (errorMessage) {
    <div class="self-center">
      <span
        class="font-base text-xs font-normal text-error-700"
        [translate]="errorMessage"
      ></span>
    </div>
  }
  <div class="flex flex-col gap-8">
    <div class="w-full">
      <app-button-atom
        [iconUrl]="isValidating ? 'assets/images/spinner.svg' : ''"
        [disabled]="isValidating || this.form.invalid"
        size="M"
        [label]="'como.validate' | translate"
        type="primary"
        [full]="true"
        (click)="onSubmit($event)"
      ></app-button-atom>
    </div>
  </div>
</div>
